import { useContext, useEffect, useState } from 'react';
import Button from '../../../../../../components/button';
import Input from '../../../../../../components/input';
import ItemCard from '../../../../../../components/itemCard';
import { Modal } from '../../../../../../components/modal';
import GlobalContext from '../../../../../../context/globalContext';
import {
  ICurrencyProvider,
  ICurrencyType,
  ISingleCurrencyType,
} from '../../../../../../interface/settings';
import { useGetCards } from '../../../../../../services/cards';

interface IWithdrawalMarkup {
  providerData?: ISingleCurrencyType;
  updateValues: (updates: Partial<ICurrencyProvider>) => void;
  isLoading: boolean;
  selectedProvider: string;
}

const WithdrawalMarkup = ({
  providerData,
  updateValues,
  isLoading,
  selectedProvider,
}: IWithdrawalMarkup) => {
  const [open, setOpen] = useState(false);
  const { providerDetails } = useContext(GlobalContext);
  const [currency, setCurrency] = useState<string>('');
  const [withdrawalMarkup, setWithdrawalMarkup] = useState<string>('');

  const { data } = useGetCards({
    conversion: 'USDNGN',
    type: providerDetails.type,
    currency: currency,
    variant: selectedProvider.toLowerCase(),
  });

  const submit = () => {
    updateValues({ withdraw: Number(withdrawalMarkup) });
    setOpen(false);
  };

  useEffect(() => {
    if (providerData)
      setCurrency(providerData.providers.currency.toLowerCase());
  }, [providerData, setCurrency]);

  useEffect(() => {
    if (providerData) {
      setWithdrawalMarkup(String(providerData.providers.withdraw));
    }
  }, [providerData, setWithdrawalMarkup]);

  return (
    <div>
      <div onClick={() => setOpen(true)}>
        <ItemCard
          title="Withdrawal Markup"
          rate={data?.data.sell}
          markup={providerData?.providers.withdraw}
        />
      </div>

      <Modal
        padding={true}
        isVisible={open}
        center
        close={setOpen}
        title="Withdrawal Markup"
        header={true}
        width="medium"
        showFooter
        footer={
          <div className="flex justify-end">
            <Button onClick={submit} disabled={isLoading} loading={isLoading}>
              Save Changes
            </Button>
          </div>
        }
      >
        <div className="flex flex-col gap-4 text-sm">
          <div>
            <div className="flex justify-between">
              <h5>Enter Amount</h5>
              <h6>C-Rate: ₦{data?.data.sell}</h6>
            </div>
            <Input
              parentClassName="mt-2"
              defaultValue={withdrawalMarkup}
              onChange={(e) => setWithdrawalMarkup(e.target.value)}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default WithdrawalMarkup;
